export const DATE_API_FORMAT = 'YYYY-MM-DD'
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY'
